import { saveAs } from 'file-saver';

export const downloadFile = (file: string, fileName: string) => {
  saveAs(file, fileName);
  //
  // const link = document.createElement('a');
  // link.href = file;
  // link.download = fileName;
  // document.body.appendChild(link);
  // link.click();
  // document.body.removeChild(link);
};

export const downloadFileByType = (blob: Blob, name: string, type: string) => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${name}.${type}`;
  link.click();
  URL.revokeObjectURL(link.href);
};
